module.exports = __webpack_public_path__ + "turtle.d6599334c39f0a313a42.gif";


//////////////////
// WEBPACK FOOTER
// /var/www/capzool/temp/src/assets/images/turtle.gif
// module id = ../../../../../src/assets/images/turtle.gif
// module chunks = styles